import React, { useEffect, useState } from "react";
import "./Events.css";
import { fetchEvents, resetStateEvents } from "../../app/slices/eventsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import moment from "moment";

const EventDetails = () => {
  const {
    data: eventsList,
    status: statusEvents,
    // error: errorEvents,
  } = useSelector(({ events }) => events.get);

  // const event = {
  //   eventName: "Lorem Ipsum Dolor",
  //   datePosted: "29/OCT/2024",
  //   eventDescription:
  //     "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat, porro cumque dignissimos eum neque dolorem! Ratione doloribus voluptate quisquam omnis mollitia cupiditate veniam illum fugit. Sunt nemo quia nisi aperiam!",
  //   coverImage:
  //     "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //   galleryImages: [
  //     "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     "https://images.unsplash.com/photo-1673905088926-eab6023079d2?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //   ],
  // };
  const [event, setEvent] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //use effects
  useEffect(() => {
    // dispatch(resetStateEvents());
    let url = new URL(window.location.href);
    const id = url?.searchParams?.get("id");
    if (id === null || id === undefined) {
      navigate("/not-found");
    } else {
      dispatch(
        fetchEvents({
          event_id: id,
        })
      );
    }
    return () => {
      dispatch(resetStateEvents());
    };
  }, []);

  useEffect(() => {
    if (eventsList?.length > 0) {
      setEvent(eventsList[0]);
    }
  }, [eventsList]);

  //methods

  //returns
  return (
    <div className="event-details app-padding">
      {statusEvents === "idle" && event !== null && (
        <>
          <img
            src={`${process.env.REACT_APP_SERVER_URL}/uploads/events/${event?.cover_image}`}
            alt=""
          />
          <h1>{event?.title}</h1>
          <small>Published On:</small>
          <p>
            {moment(event?.published_date).format("DD/MMM/YYYY")?.toUpperCase()}
          </p>
          <div className="category mb-30">
            <h3>Description</h3>
            <div className="mt-5">{event?.description}</div>
          </div>
          <div className="category ">
            <h3 className="mb-10">Event Gallery</h3>
            <div className="flex-row flex-wrap">
              {event?.images?.map((image) => (
                <div className="event-gallery-image">
                  <img
                    src={`${process.env.REACT_APP_SERVER_URL}/uploads/events/${image?.attachment}`}
                    alt=""
                  />
                </div>
              ))}
              {event?.images?.length === 0 && (
                <div
                  className="flex-row align-items-center"
                  style={{ height: "100px", color: "#999" }}
                >
                  No gallery images added to event
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {statusEvents === "loading" && (
        <LoadingContainer message={"Loading..."} />
      )}
    </div>
  );
};

export default EventDetails;
